import PropTypes from 'prop-types'

import { ConfirmationDialog } from 'components'

const DialogRemoveDataCollected = ({
  dataProcessId,
  dataCollectedId,
  open,
  setOpen,
  handleRemove,
}) => {
  return (
    <ConfirmationDialog
      open={open}
      setOpen={setOpen}
      message="Tem certeza que deseja remover este dado tratado?"
      cancelButtonText="Cancelar"
      buttonText="Continuar"
      actionAcceptButton={() => handleRemove(dataProcessId, dataCollectedId)}
    />
  )
}

DialogRemoveDataCollected.propTypes = {
  dataProcessId: PropTypes.number.isRequired,
  dataCollectedId: PropTypes.number,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
}

DialogRemoveDataCollected.defaultProps = {
  setOpen: () => {},
  handleRemove: () => {},
}

export default DialogRemoveDataCollected
